/** Routes that use LocationContext and show the site/floor selector in the app toolbar. */
export const LOCATION_LAYOUT_PATHS = new Set([
  '/location',
  '/location/overview',
  '/location/tag-fleet',
  '/location/anchor-health',
  '/location/history',
  '/location/alarms',
  '/location/tags',
  '/admin/location/floor-plans',
]);

/** Provider routes that show tenant + site/floor controls in a secondary toolbar row. */
export const PROVIDER_LOCATION_TOOLBAR_PATHS = new Set([
  '/provider/location-support',
  '/provider/location-deployment',
]);

/** Provider routes that show tenant (or similar) context controls in a secondary toolbar row. */
export const PROVIDER_CONTEXT_TOOLBAR_PATHS = new Set([
  ...PROVIDER_LOCATION_TOOLBAR_PATHS,
  '/provider/location-integration',
  '/provider/efem-setup',
  '/provider/vision/model-training',
]);

export function isLocationLayoutPath(cleanPath: string): boolean {
  return LOCATION_LAYOUT_PATHS.has(cleanPath);
}

export function isProviderLocationToolbarPath(cleanPath: string): boolean {
  return PROVIDER_CONTEXT_TOOLBAR_PATHS.has(cleanPath);
}

export function isDashboardPath(cleanPath: string): boolean {
  return cleanPath === '/' || cleanPath === '/dashboard';
}
